import { render, staticRenderFns } from "./BgAdminLayout.vue?vue&type=template&id=4342fce2&scoped=true"
import script from "./BgAdminLayout.vue?vue&type=script&lang=js"
export * from "./BgAdminLayout.vue?vue&type=script&lang=js"
import style0 from "./BgAdminLayout.vue?vue&type=style&index=0&id=4342fce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4342fce2",
  null
  
)

export default component.exports